<template>
    <v-card :height="height">
        <v-tabs
        v-model="doctab"
        :background-color="proMode ? 'grey darken-3' : 'grey lighten-3'"
        :color="proMode ? 'yellow' : 'black'"
        grow
        height="30"
        >
            <v-tab
                v-for="doc in docs"
                :key="doc.dockey"
                @click="getURL(doc.dockey,doc.filetype)"
            >
                {{ (doc.filename ? doc.filename : doc.dockey) }}
            </v-tab>
            <v-tab key="manpanel" v-if="userprof!='coder'">
                QA Man Panel
            </v-tab>
        </v-tabs>

        <v-tabs-items v-model="doctab">
            <v-tab-item
                v-for="doc in docs"
                :key="doc.dockey"
            >
                <iframe 
                    :src="activeURL" 
                    width="100%" 
                    :height="iHeight" 
                    :style="'min-height:' + iHeight + ' !important'"
                />
            </v-tab-item>
            <v-tab-item key="manpanel" v-if="userprof!='coder'">
                <v-row no-gutters class="mt-4 mb-2 pr-4 pl-2">
                    <v-col cols="9" style="text-align:center;">
                        <v-form ref="upForm" v-model="fileUploadValid">
                        <v-file-input
                            show-size
                            small-chips
                            label="Upload QA File (PHI only allowed in PDF, TXT, or IMAGE files)"
                            :accept="'image/*,' + fileTypes.join()"
                            :rules="[fileTypeRules]"
                            v-model="filename"
                            truncate-length="50"
                            @change="selectQAFile"
                            :disabled="uploading"
                        ></v-file-input>
                        </v-form>
                    </v-col>
                    <v-col cols="3">
                        <v-btn
                            :loading="uploading"
                            :disabled="uploading || !qaFileUp || !fileUploadValid"
                            block
                            color="blue-grey"
                            class="ma-2 white--text"
                            @click="uploadQAFile"
                        >
                            Upload
                            <v-icon
                                right
                                dark
                            >
                                mdi-cloud-upload
                            </v-icon>
                        </v-btn>
                    </v-col>
                </v-row>
                <v-row no-gutters class="mb-0">
                    <v-col cols="12">
                        <v-data-table
                            dense
                            :headers="qaFileHeaders"
                            hide-default-footer
                            :items-per-page="ipp100"
                            :items="docs"
                            item-key="name"
                            class="elevation-1"
                        >
                            <!-- <template v-slot:item.view="{ item }">
                                <v-row no-gutters>
                                    <v-col cols="12">
                                        <v-btn
                                            :color="proMode ? 'white' : 'black'"
                                            small
                                            text
                                            class="px-0"
                                            @click="openQADoc(item)"
                                        >
                                            <v-icon small>mdi-eye-outline</v-icon>
                                        </v-btn>
                                    </v-col>
                                </v-row>
                            </template> -->
                        </v-data-table>
                    </v-col>
                </v-row>
            </v-tab-item>
        </v-tabs-items>
    </v-card>
</template>

<script>
import { mapGetters } from "vuex";
const fileTypes = [".pdf",".txt",".rtf",".doc",".docx",".xls",".xlsx",".csv",".ppt",".pptx"];
export default {
  name: 'QADocViewer',
  props: {
    docs:Array,
    height:String,
    client:String,
    facility:String,
    proMode:Boolean,
    activeEncId:String
  },
  components: {
  },
  data () {
    return {
        doctab:null,
        sheet:false,
        iHeight:"",
        activeURL:"",
        activeDocKey:"",
        uploading:false,
        qaFileUp:null,
        filename:null,
        qaFiles:[],
        ipp100:100,
        qaFileHeaders:[
            {text:'File',value:'filename'},
            {text:'Size',value:'sizefix'},
            {text:'Uploaded',value:'uploaded'},
            //{text:'View',value:'view'}
        ],
        fileTypes:fileTypes,
        // fileTypeRules:[
        //     value => !value || !value.type.includes('image') || !this.fileTypes.includes(value.name.split(".").pop()) || 'Upload must be a supported file type.',
        // ],
        fileTypeRules: function(value){
            let out = 'Upload must be a supported file type.';
            if(!value){
                out = 'File required to Upload';
            }else if(value.type.includes('image') || fileTypes.includes('.' + value.name.split('.').pop())){
                out = true;
            }
            return out;
        },
        fileUploadValid:false,
    }
  },
  computed: {
      ...mapGetters(["userprof"]),
  },
  mounted () {
      this.getURL(this.docs[0].dockey,this.docs[0].filetype);
      this.iHeight = this.heightFix(this.height,30);
  },
  watch: {
  },
  methods: {
    heightFix(h,s){
        if(h.includes("px")){
            let v = Number(h.split("p")[0]);
            return (v-s) + "px";
        }else if(h.includes("vh")){
             let v = Number(h.split("v")[0]);
            return (v-(s/10)) + "vh";
        }else{
            return v;
        }
    },
    selectQAFile(file){
            this.qaFileUp = file;
        },
    uploadQAFile(){
        this.uploading = true;
        // console.log("File Name: " + this.qaFileUp.name);
        // console.log("File Type: " + this.qaFileUp.type);
        // console.log(this.qaFileUp);
        this.postBinary(
            "https://9ins5mn0lg.execute-api.us-east-1.amazonaws.com/v2/qa_docs/" + this.activeEncId + "/" + this.qaFileUp.name,
            this.qaFileUp,
            this.qaFileUp.type
        ).then((response) => {
            // console.log("QA UP RES: " + JSON.stringify(response));
            this.getQADocs(this.activeEncId);
            this.uploading = false;
            this.qaFileUp = null;
            this.filename = null;
        });
    },
    getQADocs:function(encid){
        this.getData(
                "https://9ins5mn0lg.execute-api.us-east-1.amazonaws.com/v2/qa_docs/" + encid
            ).then((response) => {
                // console.log("LOGS: " + response.length);
                //// console.log(JSON.stringify(response[0]));
                let filesOut = [];
                for (let r=0; r<response.length; r++){
                    let d = new Date(response[r].LastModified),
                        filename = response[r].Key.split("/").pop(),
                        filetype = filename.split(".").pop();
                    filesOut.push({
                        filename:filename,
                        sizefix:this.formatBytes(response[r].Size),
                        uploaded:d.toUTCString(),
                        dockey:response[r].Key,
                        filetype:filetype
                    });
                }
                this.docs = filesOut;
            });
    },
    formatBytes(a,b=2){if(0===a)return"0 Bytes";const c=0>b?0:b,d=Math.floor(Math.log(a)/Math.log(1024));return parseFloat((a/Math.pow(1024,d)).toFixed(c))+" "+["Bytes","KB","MB","GB","TB","PB","EB","ZB","YB"][d]},
    async getHistory(){
        // console.log("GET HISTORY");
        this.showHistory = !this.showHistory;
        if(this.showHistory){
            this.iHeight = this.heightFix(this.height,330);
        }else{
            this.iHeight = this.heightFix(this.height,30);
        }
    },
    async getURL(dockey,filetype){
        // console.log("GET URL");
        this.activeDocKey = dockey;
        let res = await this.getData("https://9ins5mn0lg.execute-api.us-east-1.amazonaws.com/v2/qa_docs/" + dockey);
        //// console.log(JSON.stringify(res));
        if(filetype){
            if(filetype.toLowerCase().includes("doc") || filetype.toLowerCase().includes("xls") || filetype.toLowerCase().includes("ppt") || filetype.toLowerCase().includes("csv")){
                // this.activeURL = "https://view.officeapps.live.com/op/view.aspx?src=" + encodeURI(res.url);
                this.activeURL = "https://docs.google.com/gview?url=" + encodeURIComponent(res.url) + "&embedded=true";
            }else{
                this.activeURL = res.url;
            }
        }else{
            this.activeURL = res.url;
        }
        // console.log(this.activeURL);
    },
    async postBinary(url = "", data = {}, type = "") {
        const session = await this.$Amplify.Auth.currentSession();
  const iT = session.getIdToken();
  const jwt = iT.getJwtToken();
        // Default options are marked with *
        const response = await fetch(url, {
        method: "POST", // *GET, POST, PUT, DELETE, etc.
        mode: "cors", // no-cors, *cors, same-origin
        cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
        headers: {
            "Content-Type": type,
            "Authorization": jwt
        },
        //redirect: 'follow', // manual, *follow, error
        //referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
        body: data, // body data type must match "Content-Type" header
        });
        return response.json(); // parses JSON response into native JavaScript objects
    },
    async getData(url = "") {
        const session = await this.$Amplify.Auth.currentSession();
  const iT = session.getIdToken();
  const jwt = iT.getJwtToken();
        // Default options are marked with *
        const response = await fetch(url, {
        method: "GET", // *GET, POST, PUT, DELETE, etc.
        mode: "cors", // no-cors, *cors, same-origin
        cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
        headers: {
            "Content-Type": "application/json",
            "Authorization": jwt
        },
        //redirect: 'follow', // manual, *follow, error
        //referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
        });
        return response.json(); // parses JSON response into native JavaScript objects
    }
  }
}
</script>

